module.exports = __webpack_public_path__ + "img/horizontal_7_2_7005.82a725af.png";